export const SAVE_EMPTY_CASE_STARTED = "SAVE_EMPTY_CASE_STARTED";
export const SAVE_EMPTY_CASE_SUCCESS = "SAVE_EMPTY_CASE_SUCCESS";
export const SAVE_EMPTY_CASE_FAILED = "SAVE_EMPTY_CASE_FAILED";

export const UPDATE_EMPTY_CASE_STARTED = "UPDATE_EMPTY_CASE_STARTED";
export const UPDATE_EMPTY_CASE_SUCCESS = "UPDATE_EMPTY_CASE_SUCCESS";
export const UPDATE_EMPTY_CASE_FAILED = "UPDATE_EMPTY_CASE_FAILED";

export const SAVE_CASEFLOW_STARTED = "SAVE_CASEFLOW_STARTED";
export const SAVE_CASEFLOW_SUCCESS = "SAVE_CASEFLOW_SUCCESS";
export const SAVE_CASEFLOW_FAILED = "SAVE_CASEFLOW_FAILED";


export const UPDATE_CASEFLOW_STARTED = "UPDATE_CASEFLOW_STARTED";
export const UPDATE_CASEFLOW_SUCCESS = "UPDATE_CASEFLOW_SUCCESS";
export const UPDATE_CASEFLOW_FAILED = "UPDATE_CASEFLOW_FAILED";

export const SAVE_WORKFLOW_STARTED = "SAVE_WORKFLOW_STARTED";
export const SAVE_WORKFLOW_SUCCESS = "SAVE_WORKFLOW_SUCCESS";
export const SAVE_WORKFLOW_FAILED = "SAVE_WORKFLOW_FAILED";
 
export const UPDATE_WORKFLOW_STARTED = "UPDATE_WORKFLOW_STARTED";
export const UPDATE_WORKFLOW_SUCCESS = "UPDATE_WORKFLOW_SUCCESS";
export const UPDATE_WORKFLOW_FAILED = "UPDATE_WORKFLOW_FAILED";

export const SAVE_EMP_BIOGRAPHICS_STARTED = "SAVE_EMP_BIOGRAPHICS_STARTED";
export const SAVE_EMP_BIOGRAPHICS_SUCCESS = "SAVE_EMP_BIOGRAPHICS_SUCCESS";
export const SAVE_EMP_BIOGRAPHICS_FAILED = "SAVE_EMP_BIOGRAPHICS_FAILED";
 
export const UPDATE_EMP_BIOGRAPHICS_STARTED = "UPDATE_EMP_BIOGRAPHICS_STARTED";
export const UPDATE_EMP_BIOGRAPHICS_SUCCESS = "UPDATE_EMP_BIOGRAPHICS_SUCCESS";
export const UPDATE_EMP_BIOGRAPHICS_FAILED = "UPDATE_EMP_BIOGRAPHICS_FAILED";

export const SAVE_H1BFORMS_STARTED = "SAVE_H1BFORMS_STARTED";
export const SAVE_H1BFORMS_SUCCESS = "SAVE_H1BFORMS_SUCCESS";
export const SAVE_H1BFORMS_FAILED = "SAVE_H1BFORMS_FAILED";
 
export const UPDATE_H1BFORMS_STARTED = "UPDATE_H1BFORMS_STARTED";
export const UPDATE_H1BFORMS_SUCCESS = "UPDATE_H1BFORMS_SUCCESS";
export const UPDATE_H1BFORMS_FAILED = "UPDATE_H1BFORMS_FAILED";

export const GET_H1BFORMS_STARTED = "GET_H1BFORMS_STARTED";
export const GET_H1BFORMS_SUCCESS = "GET_H1BFORMS_SUCCESS";
export const GET_H1BFORMS_FAILED = "GET_H1BFORMS_FAILED";


export const GET_ALLCASEFLOW_STARTED = "GET_ALLCASEFLOW_STARTED";
export const GET_ALLCASEFLOW_SUCCESS = "GET_ALLCASEFLOW_SUCCESS";
export const GET_ALLCASEFLOW_FAILED = "GET_ALLCASEFLOW_FAILED";

 
export const GET_PLAN_ALLCASEFLOW_STARTED = "GET_PLAN_ALLCASEFLOW_STARTED";
export const GET_PLAN_ALLCASEFLOW_SUCCESS = "GET_PLAN_ALLCASEFLOW_SUCCESS";
export const GET_PLAN_ALLCASEFLOW_FAILED = "GET_PLAN_ALLCASEFLOW_FAILED";
 
export const GET_ALLCASEFLOW_BYID_STARTED = "GET_ALLCASEFLOW_BYID_STARTED";
export const GET_ALLCASEFLOW_BYID_SUCCESS = "GET_ALLCASEFLOW_BYID_SUCCESS";
export const GET_ALLCASEFLOW_BYID_FAILED = "GET_ALLCASEFLOW_BYID_FAILED";

export const GET_CASEID_STARTED = "GET_CASEID_STARTED";
export const GET_CASEID_SUCCESS = "GET_CASEID_SUCCESS";
export const GET_CASEID_FAILED = "GET_CASEID_FAILED";

export const GET_CASEFLOW_INITIATION_STARTED = "GET_CASEFLOW_INITIATION_STARTED";
export const GET_CASEFLOW_INITIATION_SUCCESS = "GET_CASEFLOW_INITIATION_SUCCESS";
export const GET_CASEFLOW_INITIATION_FAILED = "GET_CASEFLOW_INITIATION_FAILED";

export const GET_EMPLOYEE_BIOG_STARTED = "GET_EMPLOYEE_BIOG_STARTED";
export const GET_EMPLOYEE_BIOG_SUCCESS = "GET_EMPLOYEE_BIOG_SUCCESS";
export const GET_EMPLOYEE_BIOG_FAILED = "GET_EMPLOYEE_BIOG_FAILED";
 
export const SAVEPDF_H1BFORMS_STARTED = "SAVEPDF_H1BFORMS_STARTED";
export const SAVEPDF_H1BFORMS_SUCCESS = "SAVEPDF_H1BFORMS_SUCCESS";
export const SAVEPDF_H1BFORMS_FAILED = "SAVEPDF_H1BFORMS_FAILED";

export const UPLOADFILE_CASEFLOW_STARTED = "UPLOADFILE_CASEFLOW_STARTED";
export const UPLOADFILE_CASEFLOW_SUCCESS = "UPLOADFILE_CASEFLOW_SUCCESS";
export const UPLOADFILE_CASEFLOW_FAILED = "UPLOADFILE_CASEFLOW_FAILED";

export const UPLOADFILE_H1BFORMS_STARTED = "UPLOADFILE_H1BFORMS_STARTED";
export const UPLOADFILE_H1BFORMS_SUCCESS = "UPLOADFILE_H1BFORMS_SUCCESS";
export const UPLOADFILE_H1BFORMS_FAILED = "UPLOADFILE_H1BFORMS_FAILED";
 


export const GET_CASEDETAILS_SUCCESS = "GET_CASEDETAILS_SUCCESS";
export const GET_CASEDETAILS_FAILED = "GET_CASEDETAILS_FAILED";
export const GET_CASEDETAILS_STARTED = "GET_CASEDETAILS_STARTED";

export const GET_ATTORNEYG28DETAILS_SUCCESS = "GET_ATTORNEYG28DETAILS_SUCCESS";
export const GET_ATTORNEYG28DETAILS_FAILED = "GET_ATTORNEYG28DETAILS_FAILED";
export const GET_ATTORNEYG28DETAILS_STARTED = "GET_ATTORNEYG28DETAILS_STARTED";

export const CREATE_H1BG28FORMS_SUCCESS = "CREATE_H1BG28FORMS_SUCCESS";
export const CREATE_H1BG28FORMS_FAILED = "CREATE_H1BG28FORMS_FAILED";
export const CREATE_H1BG28FORMS_STARTED = "CREATE_H1BG28FORMS_STARTED";

export const SAVE_ATTORNEYG28DETAILS_SUCCESS = "SAVE_ATTORNEYG28DETAILS_SUCCESS";
export const SAVE_ATTORNEYG28DETAILS_FAILED = "SAVE_ATTORNEYG28DETAILS_FAILED";
export const SAVE_ATTORNEYG28DETAILS_STARTED = "SAVE_ATTORNEYG28DETAILS_STARTED";
 

export const GET_I907FORM_STARTED = "GET_I907FORM_STARTED";
export const GET_I907FORM_SUCCESS = "GET_I907FORM_SUCCESS";
export const GET_I907FORM_FAILED = "GET_I907FORM_FAILED";
 
export const SAVE_I907FORM_STARTED = "SAVE_I907FORM_STARTED";
export const SAVE_I907FORM_SUCCESS = "SAVE_I907FORM_SUCCESS";
export const SAVE_I907FORM_FAILED = "SAVE_I907FORM_FAILED";

export const UPDATE_I907FORM_STARTED = "UPDATE_I907FORM_STARTED";
export const UPDATE_I907FORM_SUCCESS = "UPDATE_I907FORM_SUCCESS";
export const UPDATE_I907FORM_FAILED = "UPDATE_I907FORM_FAILED";


export const CREATE_I907FORMS_SUCCESS = "CREATE_I907FORMS_SUCCESS";
export const CREATE_I907FORMS_FAILED = "CREATE_I907FORMS_FAILED";
export const CREATE_I907FORMS_STARTED = "CREATE_I907FORMS_STARTED";

export const GET_EMPLOYER_LIST_STARTED = "GET_EMPLOYER_LIST_STARTED";
export const GET_EMPLOYER_LIST_SUCCESS = "GET_EMPLOYER_LIST_SUCCESS";
export const GET_EMPLOYER_LIST_FAILED = "GET_EMPLOYER_LIST_FAILED";

export const GET_PETITION_APPROVED_STARTED = "GET_PETITION_APPROVED_STARTED";
export const GET_PETITION_APPROVED_SUCCESS = "GET_PETITION_APPROVED_SUCCESS";
export const GET_PETITION_APPROVED_FAILED = "GET_PETITION_APPROVED_FAILED";
 
export const UPDATE_EMPLOYEMENT_STARTED = "UPDATE_EMPLOYEMENT_STARTED";
export const UPDATE_EMPLOYEMENT_SUCCESS = "UPDATE_EMPLOYEMENT_SUCCESS";
export const UPDATE_EMPLOYEMENT_FAILED = "UPDATE_EMPLOYEMENT_FAILED";

export const CREATE_EMPLOYEMENT_STARTED = "CREATE_EMPLOYEMENT_STARTED";
export const CREATE_EMPLOYEMENT_SUCCESS = "CREATE_EMPLOYEMENT_SUCCESS";
export const CREATE_EMPLOYEMENT_FAILED = "CREATE_EMPLOYEMENT_FAILED";

export const UPDATE_ALLEMPLOYEMENT_STARTED = "UPDATE_ALLEMPLOYEMENT_STARTED";
export const UPDATE_ALLEMPLOYEMENT_SUCCESS = "UPDATE_ALLEMPLOYEMENT_SUCCESS";
export const UPDATE_ALLEMPLOYEMENT_FAILED = "UPDATE_ALLEMPLOYEMENT_FAILED";

 

export interface IVisaCareCase {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    CaseInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
export const getAllCaseflows = (companyId,userSelectAutoId) => {
 
     return {
         type: GET_ALLCASEFLOW_STARTED ,
         payload: 'Value',
         input:companyId,
         inputparam:userSelectAutoId
     };
 };

 export const getAllCaseflowsbyCompanyId = (companyId) => {
 
     return {
         type: GET_ALLCASEFLOW_STARTED ,
         payload: 'Value',
         input:companyId 
     };
 };

 export const getAllCaseflow = (caseId) => {
 
     return {
         type: GET_CASEID_STARTED ,
         payload: 'Value',
         input:caseId 
     };
 };
 export const getAllCaseflowsByUserId = (userAutoId) => {
 
     return {
         type: GET_ALLCASEFLOW_BYID_STARTED ,
         payload: 'Value',
         input:userAutoId
     };
 };

 export const getCaseflowInitiationDetails = (caseId) => {
   
     return {
         type: GET_CASEFLOW_INITIATION_STARTED ,
         payload: 'Value',
         input:caseId
     };
 };
 export const getEmployeeBiographicsDetails = (caseId) => {
   
    return {
        type: GET_EMPLOYEE_BIOG_STARTED ,
        payload: 'Value',
        input:caseId
    };
};
export const caseflowCreateEmptyCase = (caseflowCreateEmptyCaseInput: any) => {
 
     return {
         type: SAVE_EMPTY_CASE_STARTED,
         payload: 'status',
         input: caseflowCreateEmptyCaseInput
     };
 };

 export const caseflowUpdateCase = (caseflowUpdateCaseInput: any) => {
 
    return {
        type: UPDATE_EMPTY_CASE_STARTED,
        payload: 'status',
        input: caseflowUpdateCaseInput
    };
};
export const caseflowInitiationCreate = (caseflowInitiationCreateInput: any) => {
 
    return {
        type: SAVE_CASEFLOW_STARTED,
        payload: 'status',
        input: caseflowInitiationCreateInput
    };
};

export const caseflowInitiationUpdate = (caseflowInitiationCreateInput: any) => {

   return {
       type: UPDATE_CASEFLOW_STARTED,
       payload: 'status',
       input: caseflowInitiationCreateInput
   };
};
   export const workflowCreate = (workflowCreateInput: any) => {
 
    return {
        type: SAVE_WORKFLOW_STARTED,
        payload: 'status',
        input: workflowCreateInput
    };
};

export const workflowUpdateWorkflows = (workflowUpdateWorkflowsInput: any) => {

   return {
       type: UPDATE_WORKFLOW_STARTED,
       payload: 'status',
       input: workflowUpdateWorkflowsInput
   };

};
export const employeeBiographicsCreate = (employeeBiographicsCreateInput: any) => {
 
    return {
        type: SAVE_EMP_BIOGRAPHICS_STARTED,
        payload: 'status',
        input: employeeBiographicsCreateInput
    };
};

export const employeeBiographicsUpdate = (employeeBiographicsUpdateInput: any) => {

   return {
       type: UPDATE_EMP_BIOGRAPHICS_STARTED,
       payload: 'status',
       input: employeeBiographicsUpdateInput
   };

};

export const h1bformsCreate = (h1bformsCreateInput: any) => {
 
    return {
        type: SAVE_H1BFORMS_STARTED,
        payload: 'status',
        input: h1bformsCreateInput
    };
};

export const h1bformsUpdate = (h1bformsUpdateInput: any) => {

   return {
       type: UPDATE_H1BFORMS_STARTED,
       payload: 'status',
       input: h1bformsUpdateInput
   };

};
export const getH1bformsDetails = (caseId,caseType) => {
   
    return {
        type: GET_H1BFORMS_STARTED ,
        payload: 'Value',
        input:caseId,
        inputCaseType:caseType
    };
};

export const h1bFormPdfSubmit = (caseId) => {
 
    return {
        type: SAVEPDF_H1BFORMS_STARTED,
        payload: 'Value',
        input:caseId
    };
};

export const uploadFileCaseFlow = (caseflowUploadFiles : any) => {
 
    return {
        type: UPLOADFILE_CASEFLOW_STARTED,
        payload: 'status',
        input: caseflowUploadFiles
    };
};
export const uploadFileH1BForms = (h1bFormswUploadFiles : any) => {
 
    return {
        type: UPLOADFILE_H1BFORMS_STARTED,
        payload: 'status',
        input: h1bFormswUploadFiles
    };
};

export const getCaseDetails = (caseId) => {
 
     return {
         type: GET_CASEDETAILS_STARTED ,
         payload: 'Value',
         input:caseId 
     };
 };

 export const getAttorneyG28Details = (attorneyId) => {
 
     return {
         type: GET_ATTORNEYG28DETAILS_STARTED ,
         payload: 'Value',
         input:attorneyId  
        
     };
 };

 export const generateG28Pdf = (h1g28formsInput: any) => {

    return {
        type: CREATE_H1BG28FORMS_STARTED,
        payload: 'status',
        input: h1g28formsInput
    };
 
 };

 export const saveAttorneyEligibilityInfo = (h1bg28formsInput: any) => {
 
    return {
        type: SAVE_ATTORNEYG28DETAILS_STARTED,
        payload: 'status',
        input: h1bg28formsInput
    };
};
export const getI907FormDetails = (caseId) => {
   
    return {
        type: GET_I907FORM_STARTED ,
        payload: 'Value',
        input:caseId
    };
};
export const createI907Form = (h1I907formsInput: any) => {
 
     return {
         type: SAVE_I907FORM_STARTED,
         payload: 'status',
         input: h1I907formsInput
     };
 };

 export const updateI907Form = (h1I907formsInput: any) => {
 
    return {
        type: UPDATE_I907FORM_STARTED,
        payload: 'status',
        input: h1I907formsInput
    };
};

export const generateI907Pdf = (generatePdfInput) => {
 
    return {
        type: CREATE_I907FORMS_STARTED,
        payload: 'status',
        input: generatePdfInput
    };
 
 };

 export const getAllCompanyProfileDetails = () => {
 
    return {
        type: GET_EMPLOYER_LIST_STARTED ,
        payload: 'Value' 
    };
};

export const getCaseDetailsByPetitionApproved = (companyId,filingUserName,lawfirmId,valueType) => {
 
    return {
        type: GET_PETITION_APPROVED_STARTED ,
        payload: 'Value' ,
        input:companyId, 
        inputParam:filingUserName,
        inputParamlawfirmId:lawfirmId,
        inputValue:valueType
    };
};

export const updateEmployeement = (employementInput: any) => {
 
    return {
        type: UPDATE_EMPLOYEMENT_STARTED,
        payload: 'status',
        input: employementInput
    };
};
 
export const createEmployeement = (employementInput: any) => {
 
    return {
        type: CREATE_EMPLOYEMENT_STARTED,
        payload: 'status',
        input: employementInput
    };
};

export const updateAllEmployeement = (employementInput: any) => {
 
    return {
        type: UPDATE_ALLEMPLOYEMENT_STARTED,
        payload: 'status',
        input: employementInput
    };
};

export const getAllCompanyCaseflows = () => {
 
    return {
        type: GET_ALLCASEFLOW_STARTED ,
        payload: 'Value' 
    };
};


export const getCaseflowsByPlanCompanyautoIdAndfilingUserName = (planId) => {
 
    return {
        type: GET_PLAN_ALLCASEFLOW_STARTED ,
        payload: 'Value',
        input:planId 
    };
};
  
 

 